import { call, put, takeEvery } from "redux-saga/effects";
import { getRatingDashboardSuccess, getRatingDashboardFail } from "./actions";
import { GET_RATING_DASHBOARD } from "./actionType";
import { responseHandler } from "common/CommanFunction";
import showToast from "common/Notification";
import { getRatedDashboardTask } from "helpers/fakebackend_helper";

const toastTitle = "Rating Dashboard";

function* fetchRatingDashboard({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(getRatedDashboardTask, data);
    yield call(responseHandler, toastTitle, response, getRatingDashboardSuccess, getRatingDashboardFail, onSuccess, onError, false);
  } catch (error) {
    onError(error);
    yield put(getRatingDashboardFail(error));
    showToast("error", toastTitle, error);
  }
}

export default function* ratingDashboardSaga() {
  yield takeEvery(GET_RATING_DASHBOARD, fetchRatingDashboard);
}
